export default "__VITE_ASSET__CjM$N5J5__"